import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as o, openBlock as d, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconAttestationOutline",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], h = /* @__PURE__ */ a("path", { d: "M9.442 3.558a.625.625 0 0 1 0 .884l-4 4a.625.625 0 0 1-.884 0l-2-2a.625.625 0 1 1 .884-.884L5 7.116l3.558-3.558a.625.625 0 0 1 .884 0Z" }, null, -1), p = /* @__PURE__ */ a("path", { d: "M8 1H4a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3ZM4 0a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Z" }, null, -1), f = [
  h,
  p
], m = ["id"], g = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  g
];
function I(t, b, n, q, S, e) {
  return d(), o("svg", {
    "aria-label": n.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--attestation-outline"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Attestation Outline",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${t.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, f, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${t.uniqueID}a`
      }, v, 8, m)
    ])
  ], 10, u);
}
const H = /* @__PURE__ */ r(c, [["render", I]]);
export {
  H as default
};
//# sourceMappingURL=attestation-outline.js.map
